export const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    backdropFilter: 'blur(4px)',
    animation: 'fadeIn 0.2s ease-out'
  },
  modal: {
    backgroundColor: '#ffffff',
    borderRadius: '16px',
    width: '90%',
    maxWidth: '900px',
    maxHeight: '90vh',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
    animation: 'slideUp 0.3s ease-out'
  },
  header: {
    padding: '24px 32px',
    borderBottom: '1px solid #e8ecef',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#f8f9fa'
  },
  title: {
    margin: 0,
    fontSize: '24px',
    fontWeight: '700',
    color: '#2c3e50',
    letterSpacing: '-0.5px'
  },
  closeButton: {
    background: 'none',
    border: 'none',
    fontSize: '28px',
    cursor: 'pointer',
    color: '#7f8c8d',
    padding: '4px 8px',
    lineHeight: 1,
    transition: 'all 0.2s',
    borderRadius: '8px',
  },
  customerInfo: {
    padding: '20px 32px',
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #e8ecef'
  },
  customerRow: {
    display: 'flex',
    gap: '32px',
    marginBottom: '12px'
  },
  customerItem: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  customerLabel: {
    fontSize: '13px',
    color: '#7f8c8d',
    fontWeight: '600',
    minWidth: '60px'
  },
  customerValue: {
    fontSize: '15px',
    color: '#2c3e50',
    fontWeight: '500'
  },
  tabs: {
    display: 'flex',
    padding: '0 32px',
    gap: '8px',
    backgroundColor: '#ffffff',
    borderBottom: '2px solid #e8ecef'
  },
  tab: {
    flex: 1,
    padding: '16px 20px',
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    fontSize: '15px',
    fontWeight: '600',
    color: '#7f8c8d',
    transition: 'all 0.3s',
    borderBottom: '3px solid transparent',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    position: 'relative',
    top: '2px'
  },
  tabActive: {
    color: '#3498db',
    borderBottomColor: '#3498db',
    backgroundColor: '#f0f8ff'
  },
  tabIcon: {
    fontSize: '18px'
  },
  content: {
    flex: 1,
    overflow: 'auto',
    padding: '24px 32px'
  },
  fadeIn: {
    animation: 'fadeIn 0.3s ease-out'
  },
  formSection: {
    marginBottom: '28px'
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: '700',
    color: '#2c3e50',
    marginBottom: '16px',
    paddingBottom: '8px',
    borderBottom: '2px solid #e8ecef'
  },
  formGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '16px'
  },
  formGrid3: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '16px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  label: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#5a6c7d'
  },
  input: {
    padding: '12px 16px',
    border: '2px solid #e8ecef',
    borderRadius: '8px',
    fontSize: '15px',
    transition: 'border-color 0.2s, box-shadow 0.2s',
    outline: 'none'
  },
  textarea: {
    padding: '12px 16px',
    border: '2px solid #e8ecef',
    borderRadius: '8px',
    fontSize: '15px',
    resize: 'vertical',
    minHeight: '80px',
    fontFamily: 'inherit',
    outline: 'none',
    transition: 'border-color 0.2s, box-shadow 0.2s'
  },
  // 자재 관련 스타일
  materialCount: {
    color: '#3498db',
    fontWeight: '500',
    marginLeft: '8px'
  },
  materialSearchRow: {
    display: 'flex',
    gap: '8px',
    marginBottom: '12px',
    alignItems: 'stretch'
  },
  categorySelect: {
    padding: '10px 14px',
    border: '2px solid #e8ecef',
    borderRadius: '8px',
    fontSize: '14px',
    minWidth: '120px',
    outline: 'none',
    cursor: 'pointer',
    transition: 'border-color 0.2s'
  },
  searchInputWrapper: {
    flex: 1,
    position: 'relative'
  },
  materialSearchInput: {
    width: '100%',
    padding: '10px 14px',
    border: '2px solid #e8ecef',
    borderRadius: '8px',
    fontSize: '14px',
    outline: 'none',
    transition: 'border-color 0.2s',
    boxSizing: 'border-box'
  },
  quantityInput: {
    width: '70px',
    padding: '10px 14px',
    border: '2px solid #e8ecef',
    borderRadius: '8px',
    fontSize: '14px',
    textAlign: 'center',
    outline: 'none',
    transition: 'border-color 0.2s'
  },
  searchDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: 'white',
    border: '2px solid #e8ecef',
    borderRadius: '8px',
    maxHeight: '200px',
    overflowY: 'auto',
    boxShadow: '0 8px 24px rgba(0, 0, 0, 0.12)',
    zIndex: 100
  },
  searchDropdownItem: {
    padding: '12px 16px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    borderBottom: '1px solid #f0f3f5',
    transition: 'background-color 0.2s'
  },
  searchDropdownItemActive: {
    backgroundColor: '#f0f8ff'
  },
  dropdownProductName: {
    flex: 1,
    fontWeight: '500',
    color: '#2c3e50'
  },
  dropdownStock: {
    fontSize: '13px',
    color: '#27ae60',
    fontWeight: '600'
  },
  dropdownPrice: {
    fontSize: '13px',
    color: '#7f8c8d'
  },
  usedMaterialList: {
    border: '2px solid #e8ecef',
    borderRadius: '8px',
    overflow: 'hidden'
  },
  usedMaterialItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 14px',
    borderBottom: '1px solid #f0f3f5',
    backgroundColor: '#f8f9fa'
  },
  usedMaterialInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  usedMaterialCategory: {
    fontSize: '12px',
    color: '#3498db',
    fontWeight: '600'
  },
  usedMaterialName: {
    fontSize: '14px',
    color: '#2c3e50',
    fontWeight: '500'
  },
  usedMaterialQty: {
    fontSize: '13px',
    color: '#7f8c8d'
  },
  usedMaterialPrice: {
    fontSize: '12px',
    color: '#27ae60'
  },
  usedMaterialDelete: {
    background: 'none',
    border: 'none',
    color: '#e74c3c',
    fontSize: '16px',
    cursor: 'pointer',
    padding: '4px 8px',
    borderRadius: '4px',
    transition: 'background-color 0.2s'
  },
  // 결제 관련 스타일
  paymentSummary: {
    display: 'flex',
    gap: '16px',
    marginBottom: '24px'
  },
  summaryCard: {
    flex: 1,
    minWidth: 0,
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    border: '2px solid #e8ecef',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    transition: 'all 0.2s'
  },
  summaryLabel: {
    fontSize: '13px',
    color: '#7f8c8d',
    fontWeight: '600'
  },
  summaryValue: {
    fontSize: '24px',
    fontWeight: '700',
    color: '#2c3e50'
  },
  paymentList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  paymentItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '10px',
    border: '1px solid #e8ecef',
    transition: 'all 0.2s'
  },
  paymentInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  paymentDate: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#2c3e50'
  },
  paymentDetails: {
    fontSize: '14px',
    color: '#7f8c8d',
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
  },
  paymentAmount: {
    fontWeight: '600',
    color: '#27ae60'
  },
  paymentMethod: {
    color: '#7f8c8d'
  },
  // 이력 관련 스타일
  historyList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  historyItem: {
    padding: '20px',
    backgroundColor: '#f8f9fa',
    borderRadius: '12px',
    border: '1px solid #e8ecef'
  },
  historyHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '16px',
    paddingBottom: '12px',
    borderBottom: '1px solid #e8ecef'
  },
  historyTime: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#7f8c8d'
  },
  historyUser: {
    fontSize: '13px',
    color: '#95a5a6',
    fontWeight: '600'
  },
  historyChange: {
    marginBottom: '12px',
    paddingLeft: '16px',
    borderLeft: '3px solid #3498db'
  },
  historyField: {
    fontSize: '14px',
    fontWeight: '700',
    color: '#2c3e50',
    marginBottom: '6px'
  },
  historyValues: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    fontSize: '14px'
  },
  oldValue: {
    color: '#e74c3c',
    padding: '4px 8px',
    backgroundColor: '#ffebee',
    borderRadius: '4px'
  },
  arrow: {
    color: '#95a5a6',
    fontWeight: '600'
  },
  newValue: {
    color: '#27ae60',
    padding: '4px 8px',
    backgroundColor: '#e8f8f5',
    borderRadius: '4px'
  },
  emptyState: {
    textAlign: 'center',
    padding: '48px 20px',
    color: '#95a5a6'
  },
  emptyIcon: {
    fontSize: '48px',
    display: 'block',
    marginBottom: '16px'
  },
  addButton: {
    padding: '12px 24px',
    backgroundColor: '#3498db',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s',
    marginTop: '8px'
  },
  addButtonDisabled: {
    backgroundColor: '#bdc3c7',
    cursor: 'not-allowed'
  },
  deleteButton: {
    padding: '8px 16px',
    backgroundColor: 'transparent',
    color: '#e74c3c',
    border: '2px solid #e74c3c',
    borderRadius: '6px',
    fontSize: '13px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  footer: {
    padding: '20px 32px',
    borderTop: '1px solid #e8ecef',
    display: 'flex',
    justifyContent: 'flex-end',
    gap: '12px',
    backgroundColor: '#f8f9fa'
  },
  cancelButton: {
    padding: '12px 32px',
    backgroundColor: 'transparent',
    color: '#7f8c8d',
    border: '2px solid #e8ecef',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  saveButton: {
    padding: '12px 32px',
    backgroundColor: '#27ae60',
    color: '#ffffff',
    border: 'none',
    borderRadius: '8px',
    fontSize: '15px',
    fontWeight: '600',
    cursor: 'pointer',
    transition: 'all 0.2s'
  },
  saveButtonDisabled: {
    backgroundColor: '#bdc3c7',
    cursor: 'not-allowed'
  }
};

// CSS 애니메이션
export const initStyles = () => {
  if (typeof document !== 'undefined' && !document.getElementById('edit-record-modal-styles')) {
    const styleSheet = document.createElement('style');
    styleSheet.id = 'edit-record-modal-styles';
    styleSheet.textContent = `
      @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      
      @keyframes slideUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      
      input:focus, select:focus, textarea:focus {
        border-color: #3498db !important;
        box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1) !important;
      }
    `;
    document.head.appendChild(styleSheet);
  }
};
